import { useEffect }    from 'react';
import { connect }      from 'react-redux';
// Redux
import {getFaqs}    from '../../redux/actions/Faqs';
// Components
import Head         from '../global/Head';
import Tables       from './Tables';
import Form         from './Form';
// Values
import {StateView}  from '../../values';
// Api
import {getData}    from '../../utils/faqs';


const Index = ({stateView, token, getFaqs}) => {
    const GetData = async() =>{
        const res = await getData(token)
        getFaqs(res.data)
    }
    useEffect(() =>{
        if(token){
            if(stateView === StateView.state1){
                GetData()
            }
        }
    })
    return (
        <div>
            <Head title='Preguntas fecuentes' />
            {
                stateView===StateView.state1?
                    <Tables />
                :
                    <Form />
            }
        </div>
    );
};

const mapStateToProps = state =>({
    stateView:      state.View.stateView,
    token:          state.Panel.token
})

export default connect(mapStateToProps, {getFaqs})(Index);
